<template>
  <div class="app-container">
    <!-- <el-button
      type="primary"
      @click="addMenu(0)"
      style="margin-bottom: 5px"
      v-if="roles.includes('/carport/add_type')"
      >添加</el-button
    > -->
    <el-button
      type="primary"
      plain
      @click="reset()"
      style="margin-bottom: 5px; float: right"
      >重置</el-button
    >
    <el-button
      type="primary"
      @click="(screen.page = 1), fetchData()"
      style="margin-bottom: 5px; float: right"
      >搜索</el-button
    >
    <!-- <el-select
      filterable
      style="float: right; margin-right: 10px"
      v-model="screen.park_id"
      placeholder="请选择园区"
      :disabled="userInfo.park_id != 0"
      @change="parkChange"
    >
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in parkList"
        :key="index"
      ></el-option>
    </el-select> -->
    <el-input
      style="float: right; margin-right: 10px; width: 200px"
      v-model="screen.title"
      placeholder="类型名称搜索"
    ></el-input>
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>

      <el-table-column label="类型名称" min-width="100">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.title }}</div>
        </template>
      </el-table-column>
      <el-table-column label="积分" min-width="550">
        <template slot-scope="scope">
          <span>{{ scope.row.score }}</span>
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="110">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="created_at" label="操作" width="250" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="handleSee(scope.row)"
            v-if="roles.includes('/carport/type_info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/carport/type_info')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/carport/del_type')"
            >删除</el-button
          >
          <!-- <el-button
            size="mini"
            type="success"
            @click="getRegisterUser(scope.row.id)"
            v-if="roles.includes('/hire/intention_user')"
            >意向用户列表</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <!-- <el-form-item label="选择园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="cztype == 'see' || userInfo.park_id != 0"
            @change="formParkChange"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="选择配置类型" prop="type">
          <el-select
            filterable
            v-model="ruleForm.type"
            placeholder="请选择配置类型"
            :disabled="cztype == 'see'"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="(item, index) in typeList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="配置详细" prop="score_json">
          <div v-for="(item, index) in ruleForm.sign_data" :key="index">
            <el-input class="w4" disabled v-model="item.title"></el-input>
            <el-input
              class="w4"
              placeholder="请输入签到积分"
              v-model="item.score"
              :disabled="cztype == 'see'"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit' || cztype == 'see'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import { openPark } from "@/api/index";
import {
  config_add,
  config_edit,
  config_list,
  config_del,
  config_info,
} from "@/api/userSign";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        is_page: 1,
        page: 1,
        page_size: 15,
        park_id: "",
        type: "",
        title: "",
      },
      typeList: [
        {
          title: "每日签到",
          id: 1,
        },
        {
          title: "党员签到",
          id: 2,
        },
      ],
      total: 0,
      ruleForm: {},
      rules: {
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        type: [
          { required: true, message: "请选择时间类型", trigger: "change" },
        ],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        price: [{ required: true, message: "请输入租车费用", trigger: "blur" }],
      },
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    parkChange(e) {},
    formParkChange() {},
    reset() {
      this.screen = {
        park_id: "",
        title: "",
        type: "",
        page: 1,
        page_size: 15,
        is_page: 1,
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              config_edit(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      // this.ruleForm = val
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      config_info({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        that.ruleForm = {
          id: res.data.info.id,
          sign_data: res.data.info.score_json,
          type: res.data.info.type,
        };
      });
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          config_del({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              config_add(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.cztype = "add";
      this.ruleForm = {
        type: "",
        sign_data: [
          {
            title: "星期一",
            score: "",
          },
          {
            title: "星期二",
            score: "",
          },
          {
            title: "星期三",
            score: "",
          },
          {
            title: "星期四",
            score: "",
          },
          {
            title: "星期五",
            score: "",
          },
          {
            title: "星期六",
            score: "",
          },
          {
            title: "星期日",
            score: "",
          },
        ],
      };
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },

    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      config_list(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        // this.list.forEach(item =>{
        //   item.score_json = JSON.parse(item.score_json)
        // })
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
